<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">Modelo - Serie - Fecha de vencimiento de productos</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item active">ModeloSerieFV</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="card card-secondary card-outline">
      <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
                <button class="btn btn-primary" @click="abrirModalNuevo()">Agregar nuevo Producto</button>
            </div>
              <div class="col-sm-6">
                  <div class="input-group">
                      <input type="search" v-model="txtBuscar" @keyup="listarProductos(1,txtBuscar)" class="form-control form-control-md" placeholder="Buscar por nombre">
                      <div class="input-group-append">
                          <button type="submit" class="btn btn-md btn-default">
                              <i class="fa fa-search"></i>
                          </button>
                      </div>
                  </div>
              </div> 
          </div><br>
          <div class="table-responsive">
              <table class="table table-bordered table-sm table-striped">
                  <thead class="bg-info">
                      <tr>
                          <th>Producto</th>
                          <th>Marca</th>
                          <th>Descripción</th>
                          <th>Modelo</th>
                          <th>Serie</th>
                          <th>F.Venc</th>
                          <th>Add Modelo Serie FV</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="p in productos" :key="p.id">
                          <td v-text="p.nombre"></td>
                          <td v-text="p.marca"></td>
                          <td v-text="p.descripcion"></td>
                          <td v-text="p.modelo"></td>
                          <td v-text="p.serie"></td>
                          <td>{{fechaFormateada(p.fechaVencimiento)}}</td>
                          <td>
                            <button class="btn btn-sm btn-info tooltip-btn" data-tooltip="Agregar precio" @click="abrirModalModelo('updateModelo',p,'')"
                            ><i class="fas fa-plus-square"></i></button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
           <!-- Agrega el paginador aquí -->
          <div class="row">
              <div class="col-sm-6">
                  <span>Registros: {{ totalRegistros }}</span>
              </div>
              <div class="col-sm-6">
                  <ul class="pagination pagination-sm justify-content-end">
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToFirstPage" :disabled="isOnFirstPage">Primero</a>
                      </li>
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToPreviousPage" >Anterior</a>
                      </li>
                      <li class="page-item" :class="{ active: currentPage === page }" v-for="page in visiblePages" :key="page">
                          <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToNextPage" >Siguiente</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToLastPage" :disabled="isOnLastPage">Último</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>      

  </div><!-- /.card -->

      <!--- MODAL MODELO --->
      <div v-if="showModalModelo">
      <div class="modal">
          <div class="modal-overlay"></div>
              <div class="modal-content" v-on:keyup.enter = "updateModelo()">
                  <div class="modal-header bg-primary text-white">
                      <h4>{{tituloModalModelo}}</h4>
                      <button type="button" class="close" @click="cerrarModalModelo()">&times;</button>
                  </div>
                  <div class="modal-body">
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Producto:</label>
                          <div class="col-sm-8">
                              <label for="" class="col-form-label">{{ producto }}</label>
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Modelo:</label>
                          <div class="col-sm-8">
                              <input type="text" class="form-control" v-model="modelo" style="text-transform: uppercase;">
                          </div>
                      </div>
                      <div class="mb-3 row">
                        <label for="" class="col-sm-4 col-form-label">Serie:</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" v-model="serie" style="text-transform: uppercase;">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-4 col-form-label">Fecha Vencimiento:</label>
                        <div class="col-sm-8">
                            <input type="date" class="form-control" v-model="fvencimiento">
                        </div>
                    </div>
                </div>
                    
                  <div class="container mb-2">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <button type="button" class="btn btn-secondary" @click="cerrarModalModelo()">Cerrar</button>&nbsp;
                            <button v-if="accion == 'updateModelo' " type="button" class="btn btn-primary" @click="updateModelo()">ACTUALIZAR</button>      
                        </div>
                    </div> 
                </div>
              </div>
          </div>
      </div>
  <!--- FIN MODAL MODELO --->
  <div v-if="showModalNuevo">
    <div class="modal">
        <div class="modal-overlay"></div>
      
        <div class="modal-content" v-on:keyup.enter="nuevoProducto()">
          <div class="modal-header bg-primary text-white">
            <h4>Agregar Nuevo Producto</h4>
            <button type="button" class="close" @click="cerrarModalNuevo()">&times;</button>
          </div>
      
          <div class="modal-body">
            
            <div class="mb-3 row position-relative">
              <label class="col-sm-4 col-form-label">Buscar</label>
              <div class="col-sm-6">
                <div class="combo-container">
                  <input
                    type="text"
                    v-model="busqueda"
                    @focus="mostrarDropdown = true"
                    @input="filtrarProductos"
                    placeholder="Buscar producto..."
                    class="form-control combo-input"
                  />
                  <!-- Flecha -->
                  <span class="combo-icon" @click="toggleDropdown">▼</span>
      
                  <!-- Lista de resultados -->
                  <ul
                    v-show="mostrarDropdown && resultados.length"
                    class="combo-dropdown"
                  >
                    <li
                      v-for="p in resultados"
                      :key="p.id"
                      @click="seleccionarProducto(p)"
                      class="combo-item"
                    >
                      {{ p.nombre }} - {{p.marca}}
                    </li>
                  </ul>
                </div>
              </div>
      
              <div class="col-sm-2">
                <button class="btn btn-danger" @click="borrarPorducto()">Borrar</button>
              </div>
            </div>
      
            <div class="mb-3 row">
              <label class="col-sm-4 col-form-label">Producto:</label>
              <div class="col-sm-8">
                {{ productoSeleccionado?.nombre || "-" }}
              </div>
            </div>
      
            <div class="mb-3 row">
              <label class="col-sm-4 col-form-label">Marca:</label>
              <div class="col-sm-8">
                {{ productoSeleccionado?.marca || "-" }}
              </div>
            </div>
      
            <div class="mb-3 row">
              <label class="col-sm-4 col-form-label">Precio x Unidad:</label>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="precioxunidad"
                  placeholder="0"
                />
              </div>
            </div>
      
            <div class="mb-3 row">
              <label class="col-sm-4 col-form-label">Modelo:</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  v-model="modelo"
                  style="text-transform: uppercase;"
                />
              </div>
            </div>
      
            <div class="mb-3 row">
              <label class="col-sm-4 col-form-label">Serie:</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  v-model="serie"
                  style="text-transform: uppercase;"
                />
              </div>
            </div>
      
            <div class="mb-3 row">
              <label class="col-sm-4 col-form-label">Fecha Vencimiento:</label>
              <div class="col-sm-8">
                <input type="date" class="form-control" v-model="fvencimiento" />
              </div>
            </div>
          </div>
      
          <div class="container mb-2">
            <div class="row">
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-secondary" @click="cerrarModalNuevo()">Cerrar</button>
                &nbsp;
                <button type="button" class="btn btn-primary" @click="nuevoProducto()">GRABAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  <!--- MODAL NUEVO --->

<!--- FIN NUEVO --->
    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
        <span class="sr-only">Grabando...</span>
        </div>
        <p class="text-light mt-3">Procesando, espere...</p>
    </div>
</template>

<script>
    export default{
      data(){
          return{
              idPrecioProducto:'',
              nombre:'',
              unidadMedida:null,
              categoria:null,
              modeloseriefven:'',
              modelo:'',
              serie:'',
              fvencimiento:null,
              tituloModalSKU: '',
              showModalModelo: false,
              tituloModalModelo: '',
              showModalNuevo: false,
              precioxunidad:'',
              
              productos: [],
              arrayUniMedida:[],
              errorProducto:0,
              arrayMostMsj:[],
              errorSaveUpdate:[],
              tipoAccion: 0,
              txtBuscar:'',
              idEmpresa:'',
              
              
              idVarianteP:'',

              currentPage: 1,
              totalPages: 0,
              listporPage: 15, // coincide con el paginado DRF
              visiblePages: [], // Páginas visibles en el paginado
              totalPagesToShow: 5, // Cantidad de páginas visibles en el paginado
              totalRegistros:0,
              localeSocket:null,

              loading:false,

            productosModal: [],            // todos los productos
            resultados: [],           // filtrados
            busqueda: "",             // texto del input
            productoSeleccionado: null
          }
      },
      computed: {
          isOnFirstPage() {
          return this.currentPage === 1;
          },
          isOnLastPage() {
          return this.currentPage === this.totalPages;
          },
      },
      methods:{
          updateVisiblePages() {
              const halfTotalPagesToShow = Math.floor(this.totalPagesToShow / 2);

              let startPage = Math.max(this.currentPage - halfTotalPagesToShow, 1);
              let endPage = Math.min(this.currentPage + halfTotalPagesToShow, this.totalPages);

              if (this.totalPages > this.totalPagesToShow) {
                  // Si el número de páginas es mayor que el total de páginas a mostrar, ajustamos los extremos
                  if (endPage === this.totalPages) {
                  startPage = Math.max(endPage - this.totalPagesToShow + 1, 1);
                  } else if (startPage === 1) {
                  endPage = Math.min(startPage + this.totalPagesToShow - 1, this.totalPages);
                  }
              }

              this.visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
          },
          goToPage(pageNumber) {
              // Cambiar la página actual al número de página seleccionado
              this.currentPage = pageNumber;
              // Llamar al método para obtener los datos de la página seleccionada
              this.listarProductos(pageNumber,'')
          },
          goToPreviousPage() {
              if (this.currentPage > 1) {
                  this.currentPage -= 1;
                  this.listarProductos(this.currentPage,'');
              }
          },
          goToNextPage() {
              if (this.currentPage < this.totalPages) {
                  this.currentPage += 1;
                  this.listarProductos(this.currentPage,'');
              }
          },
          goToFirstPage() {
              if (this.currentPage !== 1) {
                  this.currentPage = 1;
                  this.listarProductos(this.currentPage,'');
              }
          },

          goToLastPage() {
              if (this.currentPage !== this.totalPages) {
                  this.currentPage = this.totalPages;
                  this.listarProductos(this.currentPage,'');
              }
          },
          listarProductos(pageNumber,txtBuscar){
              let me = this
              this.$axios.get(`apinventario/modeloseriefv/?page=${pageNumber}&search=${txtBuscar}&idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                  me.productos = response.data.results
                  me.currentPage = pageNumber
                  me.totalPages = Math.ceil(response.data.count / me.listporPage)
                  me.totalRegistros = response.data.count
                  me.updateVisiblePages()
              })

          },
          validarnuevoProducto(){
              this.errorProducto = 0
              this.arrayMostMsj = []
              if (isNaN(this.precioxunidad) || this.precioxunidad < 0 || !/^\d+(\.\d+)?$/.test(this.precioxunidad)) {
                this.arrayMostMsj.push("Corrige el precio: debe ser un número positivo (ej. 1, 1.0, 5.5, 100.4)")
               }
              if(this.productoSeleccionado=='' || this.busqueda=='' || this.id == ''){
                this.arrayMostMsj.push("Seleccione un Producto")
              }
              if(!this.modelo && !this.serie && !this.fvencimiento){
                this.arrayMostMsj.push("Este producto debe tener al menos un Modelo ó Serie ó Fecha de vencimiento")
              }
              if(this.arrayMostMsj.length) this.errorProducto = 1
              return this.errorProducto
          },
          nuevoProducto(){ //Registrar nuevo producto
              if(this.validarnuevoProducto()){
                  this.arrayMostMsj.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.post(`apinventario/savemodeloseriefv/`, {
                  idProducto:me.id,
                  modelo: me.modelo.toUpperCase().trim(),
                  serie: me.serie.toUpperCase().trim(),
                  fechaVencimiento: me.fvencimiento?me.fvencimiento:null,
                  precioxunidad:me.precioxunidad,
                  idUnidadMedida:null,
              })
              .then(function (response) {
                  me.listarProductos(1,'')
                  me.cerrarModalNuevo()
                  console.log(response)
                  me.$toastr.success('Nuevo producto registrado', 'Registrado');
                  me.$socket.send(JSON.stringify({
                    'message': 'nuevo producto'
                  }))
              })
              .catch(function (error) {
                if (error.response && error.response.data) {
                    Object.values(error.response.data).forEach(err => {
                        if (Array.isArray(err)) {
                            const detalle = err[0];

                            // Si es un ErrorDetail, tendrá "string"
                            if (typeof detalle === 'object' && detalle.string) {
                                me.errorSaveUpdate.push(detalle.string)
                            } else {
                                me.errorSaveUpdate.push(detalle)
                            }
                        }
                    })
                }
                me.errorSaveUpdate.forEach(msg => {
                    me.$toastr.error(msg, 'Error')
                })

                me.errorSaveUpdate = []
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          validarUpdateProducto(){
              this.errorProducto = 0
              this.arrayMostMsj = []
              if(!this.modelo && !this.serie && !this.fvencimiento){
                this.arrayMostMsj.push("Este producto debe tener al menos un Modelo ó Serie ó Fecha de vencimiento")
              }
              if(this.arrayMostMsj.length) this.errorProducto = 1
              return this.errorProducto
          },
          updateModelo(){
            if(this.validarUpdateProducto()){
                  this.arrayMostMsj.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.patch(`apinventario/modeloseriefv/`+me.idVarianteP+`/`,{
                  modelo: me.modelo ? me.modelo.trim().toUpperCase() : null,
                  serie: me.serie ? me.serie.trim().toUpperCase() : null,
                  fechaVencimiento: me.fvencimiento?me.fvencimiento:null,
              })
              .then(function(response){
                  console.log(response)
                  me.listarProductos(me.currentPage,me.txtBuscar)
                  me.cerrarModalModelo()
                  me.$toastr.success('Producto actualizado', 'Actualizado');
              })
              .catch(function (error) {
                if(error.response && error.response.data){
                    if(error.response.data.nombre){me.errorSaveUpdate.push(error.response.data.nombre[0])}
                    if(error.response.data.codigo){me.errorSaveUpdate.push(error.response.data.codigo)}
                }
                if(me.errorSaveUpdate.length > 0){
                    me.errorSaveUpdate.forEach(element => {
                        me.$toastr.error(element,'Error')
                    });
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          eliminarProducto(id,nombre,activo){
              let me = this
              this.$swal.fire({
              title: nombre,
              text: activo ? 'Presione Si para eliminar' : 'Presione Si para restaurar',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: activo ? 'Eliminar' : 'Restaurar',
              }).then((result) => {
                me.loading=true
              if (result.isConfirmed) {
                  this.$axios.patch(`apinventario/productos/`+id+`/`,{
                    activo : activo ?  0 : 1,
                  })
                  .then(function(response){
                      console.log(response)
                      me.listarProductos(me.currentPage,me.txtBuscar)
                      me.cerrarModal()
                      if(activo){me.$toastr.success('Producto deshabilitado', 'Desactivado')}
                      else{me.$toastr.success('Producto Habilitado', 'Habilitado')}
                  })
                  .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
              }else{me.loading=false}
              })
          },
  
          abrirModalModelo(accion,data=[]){
            this.showModalModelo=true
            this.accion = accion
            this.arrayMostMsj=[]
            switch(accion){
                case 'updateModelo':{
                    console.log(data)
                    this.tituloModalModelo = 'Actualizar Modelo, Serie, Fecha de Vencimiento'
                    this.producto = data.nombre+' '+(data.marca?data.marca:'Sin marca')+', '+(data.descripcion?data.descripcion:'Sin descripcion')
                    this.modelo = data.modelo
                    this.serie = data.serie
                    this.fvencimiento = data.fechaVencimiento
                    this.idVarianteP=data.id
                    break
                }
            }      
                            
        },
        fechaFormateada(fecha) {
            if(fecha != '' && fecha){
                const partes = fecha.split('-')
                return `${partes[2]}/${partes[1]}/${partes[0]}`
            }else return ''
            
        },
          cerrarModalModelo(){
              this.showModalModelo = false;
              this.id = ''
              this.modelo=''
              this.serie=''
              this.fvencimiento=''
              this.precioxunidad=''
              this.arrayMostMsj=[]
          },

        async obtenerProductos() {
            try {
                let me = this
                //me.loading=true
                this.$axios.get(`apinventario/productonogenerico/`)
                .then(function(response){
                    me.productosModal = response.data.results || response.data
              })
                
            } catch (error) {
                console.error("Error al cargar productos:", error);
            }
        },
        filtrarProductos() {
            const term = this.busqueda.toLowerCase();
            if (term.length > 0) {
                this.resultados = this.productosModal.filter(p => 
                p.nombre.toLowerCase().includes(term)
                );
            } else {
                this.resultados = [];
            }
        },
        seleccionarProducto(producto) {
            this.productoSeleccionado = producto
            this.busqueda = producto.nombre;
            this.id = producto.id
            this.resultados = []; // cerrar dropdown
        },
        borrarPorducto(){
            this.productoSeleccionado=''
            this.busqueda=''
            this.id = ''
        },
        abrirModalNuevo(){
            this.showModalNuevo=true
            this.obtenerProductos()
        },
        cerrarModalNuevo(){
              this.showModalNuevo = false;
              this.idVarianteP=''
              this.modelo=''
              this.serie=''
              this.fvencimiento=''
              this.productoSeleccionado=''
              this.busqueda=''
              this.productosModal=[]
              this.precioxunidad=''
          },
      },
          
      watch: {
          currentPage() {
          // Actualizar las páginas visibles cuando se cambia la página actual
          this.updateVisiblePages();
          },
          totalPages() {
          // Actualizar las páginas visibles cuando se actualiza el número total de páginas
          this.updateVisiblePages();
          },
      },
      mounted(){
          this.idEmpresa = localStorage.getItem('idEmpresa')
          this.listarProductos(1,'')
          this.updateVisiblePages()
          
      }
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 40%;
  background-color: white;
  margin-top: 100px;
}
/* Estilo base del botón */
.tooltip-btn {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

/* Estilo del tooltip */
.tooltip-btn::before {
  content: attr(data-tooltip);
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 5px 10px;
  
  white-space: nowrap;
  border-radius: 4px;
  top: 50%; /* Ajusta la posición vertical según tus necesidades */
  left: 100%;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}
/* Mostrar el tooltip al hacer hover */
.tooltip-btn:hover::before {
  opacity: 1;
  visibility: visible;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
.combo-container {
  position: relative;
  width: 100%;
}

.combo-input {
  padding-right: 30px;
}

.combo-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 0.9rem;
}

.combo-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  z-index: 2000; /* 👈 mayor para sobresalir sobre modal */
  max-height: 200px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style: none;
}

.combo-item {
  padding: 8px 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.combo-item:hover {
  background-color: #007bff;
  color: white;
}

/* Asegurar que la lista no quede cortada por overflow del modal */
.modal-body {
  overflow: visible !important;
}
</style>